export default {
  bookExperiencePanel: 'Deneyim rezervasyon paneli',
  calendarIcon: 'Takvim simgesi',
  coverImageForResource: '{{title}} deneyimleri i\u00e7in kapak g\u00f6rseli',
  filterBy: '{{filter}} ile filtrele',
  filterByDateRange: 'Tarih aral\u0131\u011f\u0131na g\u00f6re filtrele',
  gallery: 'Galeri',
  goBack: '\u00d6nceki sayfaya d\u00f6n',
  hostUserIcon: 'ev sahibi kullan\u0131c\u0131 simgesi',
  imageOf: '{{title}} g\u00f6rseli',
  interactiveMapAltText:
    'Se\u00e7ilebilir {{title}} ile etkile\u015fimli harita',
  mediaSlides: 'Medya slaytlar\u0131',
  muteVideo: 'Videoyu sessize al',
  nextPhoto: 'Sonraki foto\u011fraf',
  noVideoPlayback: 'Video oynatma kapasitesi yok',
  pauseVideo: 'Videoyu duraklat',
  photoOf: '{{name}} foto\u011fraf\u0131',
  playVideo: 'Videoyu oynat',
  previousPhoto: '\u00d6nceki foto\u011fraf',
  moreFiltersAndExperiences: 'Daha fazla filtre ve deneyim',
  reserveSelectedSlot: 'Se\u00e7ilen slotu rezerve et',
  reviewRating: '5 \u00fczerinden {{rating}} de\u011ferlendirme puan\u0131',
  overallReviewRating:
    '5 \u00fczerinden {{rating}} genel de\u011ferlendirme puan\u0131',
  selectCountryCodeForPhoneNumber:
    'Telefon numaras\u0131 i\u00e7in \u00fclke kodu se\u00e7in',
  selectDate: 'Tarih se\u00e7in',
  selectParticipants: 'Kat\u0131l\u0131mc\u0131lar\u0131 se\u00e7in',
  selectSessionTime: 'Seans saatini se\u00e7in',
  unmuteVideo: 'Video sesini a\u00e7',
  viewShoppingCart:
    'Al\u0131\u015fveri\u015f sepetini g\u00f6r\u00fcnt\u00fcle',
  itemsInCart: 'Al\u0131\u015fveri\u015f sepetinde {{count}} \u00fcr\u00fcn',
  zoomIn: 'Yak\u0131nla\u015ft\u0131r',
  zoomOut: 'Uzakla\u015ft\u0131r',
  selectData: `{{data}} se\u00e7in`,
  reserveName: `{{name}} rezerve et`,
  deleteReservation: '{{experienceTitle}} rezervasyonunu sil',
  editParticipantsFor:
    '{{experienceTitle}} i\u00e7in kat\u0131l\u0131mc\u0131lar\u0131 d\u00fczenle',
  enterPromoCode: 'Promosyon kodu girin',
  applyPromoCode: 'Promosyon kodunu uygula',
  increaseAddOnAmount: 'Se\u00e7ilen {{addOn}} miktar\u0131n\u0131 art\u0131r',
  decreaseAddOnAmount: 'Se\u00e7ilen {{addOn}} miktar\u0131n\u0131 azalt',
  addOnModal: '{{addOn}} modal penceresi',
  moreInformationAboutAddOn: '{{addOn}} hakk\u0131nda daha fazla bilgi',
  decreasePriceTierTickets: '{{priceTier}} biletlerini azalt',
  increasePriceTierTickets: '{{priceTier}} biletlerini art\u0131r',
  downloadFilename: '{{filename}} indir',
  viewFullDetailsDescription:
    'T\u00fcm ayr\u0131nt\u0131lar\u0131 g\u00f6r\u00fcnt\u00fcle',
  viewFullDescription: 'Tam a\u00e7\u0131klamay\u0131 g\u00f6r\u00fcnt\u00fcle',
  closeModal: 'Modal pencereyi kapat',
  hyattBanner: 'World Of Hyatt \u00dcye \u00d6zel Banner\u0131',
  hyattBannerDesc:
    'World of Hyatt sadakat program\u0131 \u00fcyelerine sunulan \u00f6zel avantajlar\u0131 ve teklifleri belirten tan\u0131t\u0131m banner\u0131',
  previousSlide: '\u00d6nceki slayt',
  nextSlide: 'Sonraki slayt',
  paginationBulletMessage: 'Slayda git',
  exitFullscreen: 'Tam ekrandan \u00e7\u0131k',
  enterFullscreen: 'Tam ekrana ge\u00e7',
  videoSlide: 'Video slayt\u0131',
  imageSlide: 'G\u00f6rsel slayt\u0131',
  of: '/',
  noDescription: 'A\u00e7\u0131klama yok',
  mediaGallery: 'Carousel - Medya galerisi',
  dateSelector: 'Tarih seçici',
  nextWeek: 'Sonraki hafta',
  previousWeek: 'Önceki hafta',
  scheduleAgenda: 'Program ajandası',
  scheduleNav: 'Program navigasyonu',
  scheduleViewSelector: 'Program görünüm seçici',
  selectedDateAriaLabel: '{{date}}, seçili',
  tapToBookExperience: '{{title}} rezervasyonu yap',
  bookExperienceAriaLabel: '{{title}} rezervasyonu yap',
  joinWaitlistAriaLabel: '{{title}} bekleme listesine katıl',
};
